<template>
  <div class="drawer">
    <div class="drawer__stage">
      <div class="drawer__wrapper">
        <div class="drawer__content">
          <div class="drawer__content__head u-m-b0">
            <div class="button-group">
              <button
                class="button u-pos-r"
                @click.stop.prevent="openMainDrawer"
              >
                <i class="icon icon-arrow-right" />
              </button>
            </div>
            <h4><i class="icon icon-cogwheel" />Profile Settings</h4>
          </div>
          <ValidationObserver
            v-slot="{ pristine }"
            ref="form"
            tag="form"
            class="form"
            method="POST"
            @submit.prevent="save"
          >
            <div class="drawer__content__body u-m-t0">
              <ValidationProvider
                name="avatar"
              >
                <ProfileAvatar
                  v-model="form.avatar"
                />
              </ValidationProvider>

              <div class="drawer-form">
                <div class="drawer-form__group">
                  <div class="drawer-form__label">
                    <h4>Personal Details</h4>
                  </div>
                  <div class="row">
                    <div class="col col--12">
                      <FormText
                        v-model="form.username"
                        :rules="['required']"
                        name="username"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col col--12">
                      <FormText
                        v-model="form.email"
                        :rules="['required', 'email']"
                        name="email"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col col--12">
                      <FormText
                        v-model="form.name"
                        :rules="['required']"
                        name="display_name"
                      />
                    </div>
                  </div>

                  <span class="form-helptext">Never share information with other users.</span>
                </div>

                <div class="drawer-form__group">
                  <div class="drawer-form__label">
                    <h4>Security</h4>
                  </div>

                  <div class="row">
                    <div class="col col--12">
                      <FormPassword
                        v-model="form.current_password"
                        :rules="['min:6', 'max:50']"
                        name="current_password"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col col--12">
                      <FormPassword
                        v-model="form.password"
                        :rules="['min:6', 'max:50', 'confirmed:password_confirmation']"
                        name="password"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col col--12">
                      <FormPassword
                        v-model="form.password_confirmation"
                        :rules="['min:6', 'max:50']"
                        vid="password_confirmation"
                        name="password_confirmation"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="drawer__content__foot">
              <div class="button-group">
                <ButtonLoader
                  :disabled="pristine"
                  :loading="updating"
                  class="button--color-c"
                >
                  {{ pristine ? 'Saved' : 'Update' }}
                </ButtonLoader>
              </div>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import ButtonLoader from '@components/shared/ButtonLoader'
import FormText from '@components/forms/FormText'
import clone from 'lodash/clone'
import ProfileAvatar from '@components/shared/ProfileAvatar'
import FormPassword from '@components/forms/FormPassword'

export default {
  name: 'ProfileSettingsDrawer',
  components: {
    FormPassword,
    ProfileAvatar,
    FormText,
    ButtonLoader,
    ValidationObserver,
  },
  data () {
    return {
      loading: false,
      updating: false,
      form: {
        name: null,
        email: null,
        username: null,
        avatar: null,
        current_password: null,
        password: null,
        password_confirmation: null,
      },
    }
  },
  computed: {
    profile () {
      return this.$store.getters['profile/profile']
    },
  },
  async created () {
    this.loading = true
    await this.$store.dispatch('profile/getProfile')

    this.form = this.$inertia.form(clone(this.profile))

    this.loading = false
  },
  methods: {
    async save () {
      this.updating = true

      await this.form.post(this.route('profile.update'), {
        onStart: () => this.loading = true,
        onFinish: () => this.loading = false,
        onError: function (response) {
          this.$noty.error(Object.values(response)[0])
        }.bind(this),
      })

      this.form.password = null
      this.form.password_confirmation = null
      this.form.current_password = null

      this.updating = false
      this.$refs.form.reset()
    },
  },
}
</script>
